import Preacher from "../DTOs/Preacher";

// Archived preachers (GOD-33) stay in every list that shows names – past
// services still name them – but can no longer be chosen. A selection keeps
// the preacher it currently shows, even if that one has been archived since.

/** The preachers that may be chosen, plus the one currently selected. */
export function selectablePreachers(preachers: Preacher[], currentKey?: string): Preacher[] {
    return preachers.filter((p) => !p.archived || (!!currentKey && p.key === currentKey));
}

/**
 * The display name for a preacher key: "" for no key, the name if known, and
 * `deletedLabel` for a key whose preacher no longer exists (deleted for good).
 */
export function preacherDisplayName(key: string | undefined, preachers: Map<string, string>, deletedLabel: string): string {
    if (!key) return "";
    return preachers.get(key) ?? deletedLabel;
}
